class CollectionFilterDrawer extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('.collection-filter-trigger');
    this.sidebar = this.querySelector('.collection-filter-sidebar');
    this.form = this.dialog.querySelector('facet-filters-form');
    this.desktop = window.matchMedia('(min-width: 990px)');
    this.syncLayout = () => {
      clearTimeout(this.closeTimer);
      if (this.dialog.open) {
        this.dialog.close();
        document.body.style.overflow = this.previousOverflow;
      }
      this.dialog.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      (this.desktop.matches ? this.sidebar : this.dialog).append(this.form);
    };
    this.desktop.addEventListener('change', this.syncLayout);
    this.syncLayout();
    this.trigger.addEventListener('click', () => {
      clearTimeout(this.closeTimer);
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.add('is-open')));
    });
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-filter-close]') || event.target === this.dialog) this.close();
    });
    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });
  }

  close() {
    this.dialog.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      this.dialog.close();
      document.body.style.overflow = this.previousOverflow;
      this.trigger.focus();
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300);
  }

  disconnectedCallback() {
    clearTimeout(this.closeTimer);
    this.desktop?.removeEventListener('change', this.syncLayout);
    if (this.dialog?.open) document.body.style.overflow = this.previousOverflow;
    this.initialized = false;
  }
}
customElements.define('collection-filter-drawer', CollectionFilterDrawer);

class CollectionPriceSlider extends HTMLElement {
  connectedCallback() {
    this.ranges = [...this.querySelectorAll('input[type="range"]')];
    this.fields = [...this.querySelectorAll('price-range input')];
    this.ranges.forEach((range, index) => {
      range.addEventListener('input', () => {
        range.value = index === 0
          ? Math.min(Number(range.value), Number(this.ranges[1].value))
          : Math.max(Number(range.value), Number(this.ranges[0].value));
        this.fields[index].value = range.value;
        this.fields[index].dispatchEvent(new Event('change', { bubbles: true }));
        this.paint();
      });
    });
    this.fields.forEach((field, index) => field.addEventListener('change', () => {
      this.ranges[index].value = field.value || (index === 0 ? 0 : this.ranges[index].max);
      this.paint();
    }));
    this.paint();
  }

  paint() {
    const max = Number(this.ranges[1].max) || 1;
    this.style.setProperty('--price-min', `${Number(this.ranges[0].value) / max * 100}%`);
    this.style.setProperty('--price-max', `${Number(this.ranges[1].value) / max * 100}%`);
  }
}
customElements.define('collection-price-slider', CollectionPriceSlider);
